import { Container, SxProps } from '@mui/material'
import { Theme } from '@mui/material/styles'
import type { ReactNode } from 'react'
import { memo } from 'react'

interface Props {
  children: ReactNode
  smallPdLeft?: boolean
  disableBottomGutter?: boolean
  sx?: SxProps<Theme>
}

const PageContainer = ({ children, sx, smallPdLeft = false, disableBottomGutter = false }: Props) => {
  const classNames: string[] = []
  if (smallPdLeft) classNames.push('smallPdLeft')
  return (
    <Container
      maxWidth={false}
      sx={[
        {
          m: 0,
        },
        // https://mui.com/system/getting-started/the-sx-prop/#passing-the-sx-prop
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(sx) ? sx : [sx]),
        disableBottomGutter
          ? {
              pb: null,
            }
          : {
              pb: 6,
            },
      ]}
      className={classNames.join(' ')}
    >
      {children}
    </Container>
  )
}

export default memo(PageContainer)
